<app-container [authenticationRequired]="false">
  <app-login></app-login>
</app-container>
